import React, {Fragment, useState, useCallback, useEffect} from "react";
import {FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import ListView from "../../../components/ContentDisplay/ListView";
import TemplateCard from "./templateCard";
import DeleteModal from "../../../components/Modal/DeleteModal";
import {requestTemplates, deleteTemplate} from "../../../redux/Actions/reports.actions";
import {getTemplateList} from "../../../redux/Selectors/reports.selectors";

const LIST_HEADERS = ["name", "description", "appliance"];

const TemplatesTable = () => {
  const [modalOpen, toggleModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const templateList = useSelector(getTemplateList);

  useEffect(() => {
    dispatch(requestTemplates());
  }, [dispatch]);

  const handleDelete = () => {
    dispatch(deleteTemplate(selectedTemplate, () => toggleModal(false)));
  };

  const handleActionSelection = useCallback(
    (action, data) => {
      switch (action) {
        case "Edit":
          navigate(`/app/reports/${data.id}/edit-template`);
          break;
        case "Delete":
          toggleModal(true);
          setSelectedTemplate(data.id);
          break;
      }
    },
    [navigate]
  );

  return (
    <Fragment>
      {modalOpen && (
        <DeleteModal
          header={"Delete Template"}
          modalBody={"Are you sure you want to delete this template ?"}
          onClose={() => toggleModal(false)}
          onDelete={handleDelete}
          open={modalOpen}
        />
      )}
      <div className="mt-2 mt-sm-0">
        <ListView
          listItems={templateList}
          listHeaders={LIST_HEADERS}
          onSelectAction={handleActionSelection}
          withActions
          actionsList={[
            {label: "Edit", icon: FaPencil, perms: ["change_reporttemplate"]},
            {label: "Delete", icon: FaTrash, perms: ["delete_reporttemplate"]},
          ]}
          permsForActions={["change_reporttemplate", "delete_reporttemplate"]}
          cardContent={TemplateCard}
        />
      </div>
    </Fragment>
  );
};

export default TemplatesTable;
